/* eslint-disable no-magic-numbers */
import React from 'react';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import dayjs from 'dayjs';

import usePrefix from 'utils/usePrefix';
import { MessagesIp } from 'utils/api/report';

import FlexDiv from 'components/FlexDiv';
import { ObjectReportWrapper, UsersList } from 'components/TableContainer/styles';
import EmptyList from 'components/EmptyList';
import NoResults from 'components/NoResults';
import Row from 'components/Row';
import { Value } from 'components/DataCell/styles';

import { Content } from '../styles';
import { ReportType } from '../Criteria';

interface Props {
  objectData?: { reportType: ReportType, data: MessagesIp[] };
}

const MessagesIpReport: React.FC<Props> = ({objectData}) => {
  const t = usePrefix('Reports');

  return (
    <FlexDiv
      justifyContent="flex-start"
      alignItems="flex-start"
      alignContent="flex-start"
      flexDirection="column"
      flex="1"
      width="100%"
    >
      <Content>
        <ObjectReportWrapper>
          {(!objectData?.data?.length) && (
            <EmptyList>
              <NoResults title={t('no_data')} />
            </EmptyList>
          )}
          {(!!objectData?.data?.length) && (
            <UsersList>
              <AutoSizer disableWidth>
                {({ height }: { height: number }) => (
                  <List
                    height={height}
                    width="100%"
                    itemCount={objectData.data.length}
                    itemSize={48}
                    innerElementType="ul"
                  >
                    {({ index, ...props }) => {
                      const item = objectData.data[index];
                      const connectionInfo = item.reporterConnectionInfo ?? '-';
                      return (
                        <Row
                          title={t(`${item.type}`)}
                          labels={[
                            t(`${item.type}`),
                            `${dayjs(new Date(item.send)).format('H:mm:ss:SSS')},
                          ${dayjs(new Date(item.send)).format('DD-MM-YYYY')}`,
                            `${item.ip ? item.ip : '0.0.0.0'}`,
                            `${item.port ?? '-'}`,
                            `${item.agent ?? '-'}`,
                          ]}
                          cellChildren={
                            <Value title={item.reporterConnectionInfo ?? ''}>
                              {connectionInfo.length > 60
                                ? `${connectionInfo.substring(0, 60)}…`
                                : connectionInfo}
                            </Value>
                          }
                          {...props}
                        />
                      );
                    }}
                  </List>
                )}
              </AutoSizer>
            </UsersList>
          )}
        </ObjectReportWrapper>
      </Content>
    </FlexDiv>
  );
};

export default MessagesIpReport;
